export default {
  inquiries: [],
};
